import axiosInstance from '../utils/AxiosConfig';

const unwrap = (response) => response.data?.data ?? response.data;

/** Cotizaciones vigentes (con antigüedad) y monedas habilitadas del tenant. */
export const getCurrentRates = async () => unwrap(await axiosInstance.get('/exchange-rates/current'));

/** Conversión para mostrar: precio en la moneda, cotización usada (con fecha) y total en UYU. */
export const getQuote = async (amount, currency) =>
  unwrap(await axiosInstance.get('/exchange-rates/quote', { params: { amount, currency } }));

/** Carga una cotización manual (pisa a la del BCU del mismo día). */
export const saveManualRate = async ({ currency, rate, date }) =>
  unwrap(await axiosInstance.put('/exchange-rates/manual', { currency, rate, date }));

/** Habilita las monedas del tenant. UYU siempre queda habilitada. */
export const saveEnabledCurrencies = async (currencies) =>
  unwrap(await axiosInstance.put('/exchange-rates/enabled-currencies', { currencies }));
